import PropTypes from 'prop-types';

export const PopupPropTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.any,
  customTitle: PropTypes.node,
  isCloseHidden: PropTypes.bool,
  level: PropTypes.number,
  title: PropTypes.node,
};

export const PopupDefaultProps = {
  isCloseHidden: false,
  level: 1,
};
